// file re-exports for legacy usage
import * as notifications from "../notifications";

/** @deprecated Import path is deprecated, use `@/common/notifications` instead */
export const useNotification = notifications.useNotification;
/** @deprecated Import path is deprecated, use `@/common/notifications` instead */
export const useNotify = notifications.useNotify;
